import { StyledDialog } from '@lib/common';
import { FormStatus } from '@lib/state';
import { Button, DialogActions, DialogContent, Typography } from '@material-ui/core';
import React from 'react';

interface Props {
  open: boolean;
  draft: boolean;
  disable?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  status: FormStatus;
}

export function InvoiceRunGenerateModal({
  open,
  draft,
  disable = false,
  onClose,
  onConfirm,
  status,
}: Props) {
  const invoiceMessage = !disable
    ? 'This invoice export has expired. Create a new draft invoice run to generate a new export.'
    : 'No invoice export has been generated.';

  return (
    <StyledDialog open={open} title="Export Not Generated" onClose={onClose}>
      <DialogContent>
        {!draft && !disable ? (
          <>
            <Typography variant="body1" align="center" style={{ margin: '1rem' }}>
              An export for this run has not been generated. Would you like to generate it now?
            </Typography>
            <Typography variant="subtitle1" align="center" style={{ margin: '1rem' }}>
              This may take a few minutes. You will be able to download the invoices once the export
              is complete.
            </Typography>
          </>
        ) : (
          <Typography variant="body1" align="center" style={{ margin: '1rem' }}>
            {invoiceMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="contained"
          color="default"
          disabled={!!status && status === FormStatus.Pending}
          onClick={onClose}
          data-testid="cancelButton"
        >
          Cancel
        </Button>
        {!draft && !disable && (
          <Button
            type="button"
            variant="contained"
            color="primary"
            disabled={!!status && status === FormStatus.Pending}
            onClick={onConfirm}
            data-testid="confirmButton"
          >
            Confirm
          </Button>
        )}
      </DialogActions>
    </StyledDialog>
  );
}
